import React from "react";
import PropTypes from "prop-types";

const findValue = (data = [], name) => {
  return data.find((ele) => ele.module === name);
};
function ModuleInput({ data, handleOnChange, values }) {
  const value = findValue(values, data.module);
  return (
    <div className="create-module__formControl">
      <label
        htmlFor={`module-${data.id}`}
        className="create-module__formControl--label"
      >
        {data.label}
      </label>
      <div className="create-module__formControl--input">
        <input
          id={`module-${data.id}`}
          name={data.module}
          onChange={handleOnChange}
          value={(value && value.name) || ""}
          placeholder={data.placeholder}
        />
      </div>
    </div>
  );
}

ModuleInput.propTypes = {
  data: PropTypes.object.isRequired,
  values: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
};

export default ModuleInput;
